/* eslint-disable arrow-body-style */

import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { Fragment } from "react";
import { PolicyHolderDetailsForm } from "./PolicyHolderDetailsForm";

export const PolicyHolderDetailsStep = () => {
  return (
    <CommonUI
      FormComponent={PolicyHolderDetailsForm}
      headingText="Let’s add the policyholder’s details"
      metaTitle="Let’s add the policyholder’s details"
      bodyText={
        <Fragment>
          To verify coverage, we need details about the person whose name is on the insurance plan.
        </Fragment>
      }
    />
  );
};
